// extracted by mini-css-extract-plugin
module.exports = {"module":"ModuleTextList_module__2AK4N","checkboxSquare":"ModuleTextList_checkboxSquare__2h6gf","checkboxCircle":"ModuleTextList_checkboxCircle__1UXPW"};